import NextLink from 'next/link'
import clsx from 'clsx'
import { forwardRef } from 'react'

// const isURL = (str) => {
//     const pattern = new RegExp(
//         '^https?:\\/\\/' + // protocol,
//             'i'
//     ) // fragment locator
//     return !!pattern.test(str)
// }

const Link = forwardRef(
    (
        {
            children,
            href,
            external = false,
            target,
            download,
            className,
            style,
            color,
            hoverColor,
            onClick,
            backgroundColor
        },
        ref
    ) => {
        /* eslint-disable indent */
        const linkCss = (theme) => {
            return `
        color: ${theme.colors[color] || theme.colors.medGray}; ${
                backgroundColor
                    ? ''
                    : `&:hover {
                    color: ${theme.colors[hoverColor] || theme.colors.primary};
                }`
            }
                
                cursor: pointer;
                `
        }

        const bgLink = (theme) => {
            return `
        cursor: pointer;
        ${
            backgroundColor &&
            `background-color: ${theme.colors[backgroundColor]};
             &:hover {
                    box-shadow: ${theme.boxShadow.lg};
                }`
        };
        ${style}
            `
        }
        /* eslint-enable indent */

        const linkBody =
            external === true ? (
                <span className="external-link" css={bgLink}>
                    <a
                        href={href}
                        download={download}
                        target={target}
                        css={linkCss}
                        onClick={onClick}
                        ref={ref}
                    >
                        {children}
                    </a>
                </span>
            ) : (
                <span className="internal-link" css={bgLink}>
                    <NextLink href={href}>
                        <a onClick={onClick} css={linkCss} ref={ref}>
                            {children}
                        </a>
                    </NextLink>
                </span>
            )
        return (
            <div className={clsx('link inline-block', className)}>
                {linkBody}
            </div>
        )
    }
)

export default Link
